import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectRetreatFlowing } from './selectors';
import { chooseBenchPosition, retreatStart } from './actions';
import { selectActivePokemon, selectIsMainPhase, selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';
import { setContextMenu } from '../ActiveGame/actions';
import { RETREAT } from '../ActiveGame/contextMenuTypes';
import { Button, Muted } from '../Controls';
import { EnergyCost } from '../Energy';

/**
 * Starts a retreat: first pick the energy to discard for the retreat cost (if any), then the benched Pokémon to
 * switch in.
 */
const RetreatButton = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const options = useSelector(selectOptions);
  const isMainPhase = useSelector((state) => selectIsMainPhase(state, { userId }));
  const retreatFlowing = useSelector(selectRetreatFlowing);

  if (!isMainPhase || !activePokemon) {
    return null;
  }

  const retreatCost = activePokemon.getIn(['card', 'retreat_cost']) || 0;
  // Whether it can retreat, and why not, is the server's call (asleep, no bench, not enough energy...).
  const reason = optionReason(options && options.get('retreat'));

  const start = () => {
    if (retreatCost === 0) {
      dispatch(chooseBenchPosition());
      return;
    }
    dispatch(retreatStart());
    dispatch(setContextMenu(RETREAT, userId));
  };

  return (
    <>
      <Button onClick={start} disabled={retreatFlowing || !!reason}>
        Retreat
        {retreatCost > 0 && <> <EnergyCost types={Array(retreatCost).fill('colorless')} /></>}
      </Button>
      {reason && <Muted>{reason}</Muted>}
    </>
  );
};

RetreatButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default RetreatButton;
